(async () => {

    // Bail if this JS is loaded outside of WordPress
    if (CC_CONSTANTS.isNonWp) {
        console.cclog('Skipping alertsapi2-render-www...');
        return;
    }

    if (document.readyState === 'loading') {
        await new Promise(resolve => document.addEventListener('DOMContentLoaded', resolve, { once: true }));
    }

    const allAlerts = await window.ALERTSAPI.getAlerts()
        , nonExpiredAlerts = allAlerts.filter(a => {
            if (a?.display_until || !Date.parse(a.display_until)) return true;
            if (now.getTime() > (new Date(a.display_until)).getTime()) return true;
            return false;
        })
        , alerts = nonExpiredAlerts;


        console.cclog('allAlerts:', allAlerts);

        /* renderAlert
        * Renders a single alert in HTML
        * @param {object} alert The alert to render
        */
    function renderAlert(alert) {
        // let dismissText = alert.style === 'danger' ? 'Close Announcement' : 'Dismiss Alert for 2 Hours';
        let dismissText = alert.style === 'danger' ? 'Dismiss Alert for 2 Hours' : 'Close Announcement';
        console.cclog('Rendering single alert:', alert);
        const tradDesktopLoc = document.querySelector("div.cc-special-announcements");
        if (tradDesktopLoc) {
            const template = `
            <aside id="alert-${alert.id}" class="container-fluid special-announcement special-announcement-${alert.style} alert alert-dismissible fade show">
                <div class="wrapper-fluid sm-type">
                    <div class="row p-2 justify-content-between align-items-center">
                        <div class="col-auto p-0 px-sm-1 px-lg-2">
                            <div class="title-btn-wrap">
                                <button role="button" class="btn btn-collapse collapsed-list-btn collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#${alert.style}-${alert.id}" aria-expanded="false" aria-controls="${alert.style}-${alert.id}" aria-label="${alert.title} - Read More"><strong>${alert.title}</strong> <i class="icon fa-sharp fa-solid fa-angle-down"></i></button>
                            </div>
                            <div class="collapse" id="${alert.style}-${alert.id}">
                                <div class="pt-1">${alert.summary}</div>
                            </div>
                        </div>
                        <div class="col-auto p-0 px-sm-1 px-lg-2">
                            <button type="button" class="col-auto d-flex align-items-center justify-content-center btn-close tooltip" data-bs-dismiss="alert" aria-label="${dismissText}" title="${dismissText}"><span class="tooltip-text">${dismissText}</span><i class="fa-regular fa-xmark icon"></i></button>
                        </div>
                    </div>
                </div>
            </aside>`;

            // Create a temporary div to hold the alert
            let tempDiv = document.createElement('div');
            tempDiv.innerHTML = template;

            // Get the alert element from the temporary div
            let alertElement = tempDiv.firstElementChild;

            // Get the close button for this alert
            let closeButton = alertElement.querySelector('.btn-close');

            // Append the alert element to tradDesktopLoc
            tradDesktopLoc.appendChild(alertElement);

            // Pass the alert to the processClosedAlerts function
            processClosedAlerts(closeButton, alert);
        }
    }

    /* processClosedAlerts
    * Adds an event listener to the close button for each alert
    * @param {HTMLElement} btn The close button element
    * @param {object} alert The alert to close
    */
    function processClosedAlerts(btn, alert) {
        console.cclog('Processing closed alert:', alert);
        
        btn.addEventListener('click', () => {
            // Track the closed state for all alerts, not just danger
            let closedAlerts = JSON.parse(localStorage.getItem('cc-alerts-api-ui-state')) || [];
    
            const mostRecentEntries = new Map();
            
            // Populate existing entries into the map
            if(closedAlerts && closedAlerts.length > 0) {
                closedAlerts.forEach(item => {
                    mostRecentEntries.set(item.id, item);
                });
            }
            
            // Add or update the current alert with a new timestamp
            mostRecentEntries.set(alert.id, { id: alert.id, time: Date.now() });
    
            const updatedData = Array.from(mostRecentEntries.values());
            localStorage.setItem('cc-alerts-api-ui-state', JSON.stringify(updatedData));
        });
    
        // Check if the alert should be hidden on page load
        let closedAlerts = JSON.parse(localStorage.getItem('cc-alerts-api-ui-state')) || [];
        let closedAlert = closedAlerts.find(a => a.id === alert.id);
        const isHidden = isAlertHidden(alert.id);
    
        if (closedAlert) {
            const currentTime = Date.now();
            const timePassed = currentTime - closedAlert.time;
            
            // Wait times: 2 hours for danger, 12 hours for everything else
            const waitTime = alert.style === 'danger' 
                ? 2 * 60 * 60 * 1000 
                // ? 5 * 60 * 1000
                : 12 * 60 * 60 * 1000;
                // : 1 * 60 * 1000;
    
            if (timePassed < waitTime || isHidden) {
                document.querySelector(`#alert-${alert.id}`).style.display = 'none';
            }
        } else if (isHidden) {
            document.querySelector(`#alert-${alert.id}`).style.display = 'none';
        }
    }

    if (alerts.length) renderAlerts();

    /* renderAlerts
    * Passes all alerts that are not hidden to renderAlert
    */
    function renderAlerts() {
        console.cclog('Rendering alerts:', alerts);
        console.cclog('hiding alerts:', ALERTSAPI.hideAnnouncements);

        const isPortal = isPortalPage();

        alerts.forEach(alert => {
            const isHidden = isAlertHidden(alert.id);

            // Debug
            if (window.cc_debug_flag) {
                console.group(`Alert ID: ${alert.id}`);
                console.log(`Title: ${alert.title}`);
                console.log(`Summary: ${alert.summary}`);
                console.log(`Type: ${alert.type}`);
                console.log(`Style: ${alert.style}`);
                console.log(`Date Added: ${alert.date_added}`);
                console.log(`Display Until: ${alert.display_until}`);
                console.log(`Author: ${alert.author}`);
                console.log(`Last Edited By: ${alert.last_edited_by}`);
                console.log(`Date Edited: ${alert.date_edited}`);
                console.groupEnd();
            }

            // If the alert is not hidden, check its type
            if (!isHidden) {
                // If the alert type is WWW or WWWTest, render it on any page
                if (alert.type[0].startsWith('WWW')) {
                    renderAlert(alert);
                }
                // If the alert type is StaffPortal or StaffPortalTest, render it only on staff portal pages
                else if (alert.type[0].startsWith('StaffPortal') && isPortal === 'StaffPortal') {
                    renderAlert(alert);
                }
                // If the alert type is StudentPortal or StudentPortalTest, render it only on student portal pages
                else if (alert.type[0].startsWith('StudentPortal') && isPortal === 'StudentPortal') {
                    renderAlert(alert);
                }
            }
            // renderAlert(alert);
        });
    }

    /* isAlertHidden
    * Check if an alert is in the hideAnnouncements array
    * @param {number} alertId The ID of the alert to check
    * @returns {boolean} Returns true if the alert is hidden
    */
    function isAlertHidden(alertId) {
        console.cclog('Checking if alert is hidden:', alertId);
        return ALERTSAPI.hideAnnouncements.some(hiddenAlert => {
            // Extract the ID from the slug
            const hiddenAlertId = parseInt(hiddenAlert.slug.split('-')[0]);
            return hiddenAlertId === Number(alertId);
        });
    }

    /* isPortalPage
    * Check if the current page is a staff or student portal page
    * @returns {boolean} Returns true if the current page is a staff or student portal page
    *
    * Need to include announcementChannels
    */
    function isPortalPage() {
        console.cclog('Checking if page is portal page');
        // Check if ALERTSAPI.staffPortalPages and ALERTSAPI.studentPortalPages are in the current path
        const pageUrl = window.location.pathname;
        const isStaffPortal = ALERTSAPI.staffPortalPages.some(page => pageUrl.includes(page.post_name));
        console.cclog('isStaffPortal:', isStaffPortal);
        const isStudentPortal = ALERTSAPI.studentPortalPages.some(page => pageUrl.includes(page.post_name));
        console.cclog('isStudentPortal:', isStudentPortal);
        // return isStaffPortal || isStudentPortal;
        if (isStaffPortal) {
            console.cclog('This is a Staff Portal page');
            return 'StaffPortal';
        } else if (isStudentPortal) {
            console.cclog('This is a Student Portal page');
            return 'StudentPortal';
        }
    }

})();
